import React from 'react';
import image from '../../image/success.gif'

const Success = () => {
    return (
        <div className="d-flex justify-content-center align-items-center bg-light">
        <img src={image} alt="" />
        
        </div>
    );
};

export default Success;